// extracted by mini-css-extract-plugin
module.exports = {"clockDetailsContainer":"ClockOutModal_clockDetailsContainer__2JYHD"};